import { Injectable, Inject } from '@angular/core';
import { ReflectiveInjector } from '@angular/core';

import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService, Token } from './index';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let providers = ReflectiveInjector.resolve([AuthenticationService]);
        let injector = ReflectiveInjector.fromResolvedProviders(providers);
        let authenticationService = injector.get(AuthenticationService);

        if (!authenticationService.isTokenValid()) {
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }

        return true;
    }

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/services/security/auth.guard.ts